import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { Acompanhamento } from "../../../types/processo/Acompanhamento";
import { AcompanhamentoDTO } from "../../../types/processo/AcompanhamentoDTO";

import { Processo } from "../../../types/processo/Processo";


const endpointUrl = configUrls.PROCESSO_ACOMPANHAMENTO_EP


function createAcompanhamento(obj: Acompanhamento) {
    return {
        url: `${endpointUrl}/create`,
        method: "POST",
        body: obj,
    }
}

function updateAcompanhamento(obj: Acompanhamento) {
    return {
        url: `${endpointUrl}/${obj.id}`,
        method: "PUT",
        body: obj,
    }
}

function deleteAcompanhamento({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/${id}`,
        method: "DELETE",
    }
}

function getAcompanhamentosByProcesso(processo: Processo) {
    if (!processo || !processo.id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/processo/${processo.id}`,
        method: "GET",
    }
}

export const acompanhamentoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getAcompanhamento: query<Acompanhamento, string>({
            query: (id) => `${endpointUrl}/${id}`,
            providesTags: ["Acompanhamento"],
        }),

        getAcompanhamentosByProcesso: query<Acompanhamento[], Processo>({
            query: getAcompanhamentosByProcesso,
            providesTags: ["Acompanhamento"],
        }),

        createAcompanhamento1: mutation<Acompanhamento, Acompanhamento>(
            {
                query: createAcompanhamento,
                invalidatesTags: ["Acompanhamento"]
            }),


        createAcompanhamento: mutation<Acompanhamento, AcompanhamentoDTO>(
            {
                query: (obj) => ({
                    url: `${endpointUrl}/create`,  // Usando a variável endpointUrl diretamente
                    method: 'POST',    // Método POST para criar o acompanhamento
                    body: obj,         // Corpo da requisição com os dados do novo acompanhamento
                }),
                invalidatesTags: ["Acompanhamento"]
            }),

        updateAcompanhamento: mutation<Acompanhamento, Acompanhamento>({
            query: updateAcompanhamento,
            invalidatesTags: ["Acompanhamento"]
        }),

        deleteAcompanhamento: mutation<Acompanhamento, { id: string }>(
            {
                query: deleteAcompanhamento,
                invalidatesTags: ["Acompanhamento"],
            }),
    }),

});
export const {
    useGetAcompanhamentoQuery,
    useGetAcompanhamentosByProcessoQuery,
    useCreateAcompanhamentoMutation,
    useUpdateAcompanhamentoMutation,
    useDeleteAcompanhamentoMutation,
    //useCreateAcompanhamento1Mutation,
} = acompanhamentoApiSlice